import React, { PropsWithChildren, FC } from "react";

import "./index.scss";

export const WarningAlert: FC<PropsWithChildren<any>> = (props) => (
  <div className="WarningAlert" {...props}></div>
);
